import { render } from "./updateRate.vue?vue&type=template&id=7475e3d0&scoped=true"
import script from "./updateRate.vue?vue&type=script&lang=js"
export * from "./updateRate.vue?vue&type=script&lang=js"

import "./updateRate.vue?vue&type=style&index=0&id=7475e3d0&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7475e3d0"]])

export default __exports__